import FileSaver from 'file-saver'
import {GetterTree, MutationTree, Module, ActionTree} from 'vuex'
import {RootState, DocumentState} from '../types'
import {apiUrl} from '@/config/service'
import axios from 'axios'

type DocumentGetter = GetterTree<DocumentState, RootState>

const state: DocumentState = {
  document: null,
  documentsGeneriques: null
}

export const getters: DocumentGetter = {
  documentGetter: (state) => state.document,
  documentsGeneriquesGetter: (state) => state.documentsGeneriques
}

export const actions: ActionTree<DocumentState, RootState> = {
  async getDocumentAction({commit}, {ID, NOM_FICHIER}) {
    const {data} = await axios.get(`${apiUrl}/document/${ID}/download`, {responseType: 'arraybuffer'})
    const u8 = new Uint8Array(data)
    const b64encoded = btoa(
      [].reduce.call(
        new Uint8Array(data),
        (p, c) => {
          return p + String.fromCharCode(c)
        },
        ''
      )
    )
    return {nomFichier: NOM_FICHIER, dataFichier: b64encoded}
  },
  async downloadDocumentAction({commit}, {ID, NOM_FICHIER}) {
    const {data} = await axios.get(`${apiUrl}/document/${ID}/download`, {responseType: 'arraybuffer'})
    commit('downloadDocumentMutation', {data, NOM_FICHIER})
    return data
  },
  async getDocumentsGeneriquesAction({commit}) {
    const {data} = await axios.get(`${apiUrl}/document/genericList`)
    commit('getDocumentsGeneriquesMutation', data)
    return data
  },
  async getDocumentByIdAction({commit}, id) {
    commit('resetDocumentMutation')
    const {data} = await axios.get(`${apiUrl}/document/${id}`)
    commit('getDocumentByIdMutation', data)
    return data
  },
  async updateDocumentAction({commit}, {id, formParams}) {
    const {data} = await axios.put(`${apiUrl}/document/${id}`, formParams)
    return data
  },
  async deleteDocumentAction({commit}, id) {
    const {data} = await axios.delete(`${apiUrl}/document/${id}`)
    commit('deleteDocumentMutation', id)
    return id
  },
  async syncDocumentAction({commit}, syncData) {
    const {data} = await axios.post(`${apiUrl}/document/sync`, {data: syncData})
    return data
  }
}

const mutations: MutationTree<DocumentState> = {
  getDocumentByIdMutation(state, data) {
    state.document = data
  },
  getDocumentsGeneriquesMutation(state, data) {
    state.documentsGeneriques = data
  },
  downloadDocumentMutation(state, {data, NOM_FICHIER}) {
    const arr = new Uint8Array(data)
    const blob = new Blob([data])
    FileSaver.saveAs(blob, NOM_FICHIER)
  },
  deleteDocumentMutation(state, id) {
    console.log('delete document')
  },
  resetDocumentMutation(state) {
    state.document = null
  }
}

export const document: Module<DocumentState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true
}
